
import { Vue, Options } from "vue-class-component";
import { Http, ResponseData } from "../../net/Http";
import { Urls } from "../../net/Urls";
import { CurWinner } from "../../model/lottery/LotteryModel";
import LotteryTitle from "../../components/lottery/LotteryTit.vue";
import LotteryMore from "../../components/lottery/LotteryMore.vue";
import { openToast } from "toast-ts";
@Options({
  components: {
    LotteryTitle,
    LotteryMore
  }
})
export default class WinnersList extends Vue {
  isShow = false;
  curWinner: CurWinner | null = null;
  mounted() {
    Http.get<CurWinner>(Urls.lottery_curWinner).then(
      (res: CurWinner) => {
        this.curWinner = res;
        this.isShowWinner();
      },
      (err: ResponseData) => {
        console.log("WinnersList:", err.message);
        openToast(err.message);
      }
    );
  }
  isShowWinner() {
    if (
      this.curWinner != null &&
      this.curWinner.luckyCode.length > 0 &&
      this.curWinner.userName.length > 0
    ) {
      this.isShow = true;
    } else {
      this.isShow = false;
    }
  }
  moreList() {
    this.$router.push("/pasewinners/list");
  }
  allLuckCode() {
    this.$router.push("/luckycodes/list");
  }
}
